<template>
  <div id="pantalla-inicio">
    <div v-if="feedbackMessage" class="position-fixed top-0 end-0 p-3" style="z-index: 2000;">
      <div :class="['alert', feedbackType === 'error' ? 'alert-danger' : 'alert-success', 'shadow-sm', 'mb-0']">
        {{ feedbackMessage }}
      </div>
    </div>
    <!-- Navegación (sin cambios) -->
    <AppNavbar />
    <!-- Contenido Principal -->
    <div class="container mt-4 flex-grow-1 sales-screen">
      <!-- Indicador de Modo Edición -->
      <div v-if="modoEdicion" class="alert alert-info alert-dismissible fade show mb-3" role="alert">
        <i class="bi bi-pencil-square me-2"></i>
        <strong>Modo Edición:</strong> Estás editando el Pedido #{{ pedidoIdEdicion }}
        <button type="button" class="btn-close" @click="cancelarEdicion" aria-label="Close"></button>
      </div>
      <div v-else-if="modoRetomar" class="alert alert-warning alert-dismissible fade show mb-3" role="alert">
        <i class="bi bi-arrow-repeat me-2"></i>
        <strong>Modo Retomar:</strong> Estás completando el Pedido #{{ pedidoIdRetomar }} para enviarlo a caja
        <button type="button" class="btn-close" @click="cancelarRetomar" aria-label="Close"></button>
      </div>

      <!-- Modo cajero único: sin caja abierta no se bloquea la carga, solo se avisa -->
      <div
        v-if="mostrarBannerCajaCerrada"
        class="alert alert-warning d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3"
        role="alert"
      >
        <div>
          <i class="bi bi-exclamation-triangle me-2"></i>
          Necesitás tu caja abierta para cobrar desde esta pantalla. Abrí tu caja o pedí que otra persona cobre el pedido.
        </div>
        <button type="button" class="btn btn-warning btn-sm" @click="irAAbrirCaja">
          Abrir caja <i class="bi bi-arrow-right ms-1"></i>
        </button>
      </div>

      <div class="sales-context-card card border-0 shadow-sm mb-3 d-lg-none">
        <div class="card-body py-3">
          <div class="sales-context-card__eyebrow">Mostrador</div>
          <div class="sales-context-card__title">{{ salesMobileTitle }}</div>
          <div class="sales-context-card__subtitle">{{ salesMobileSubtitle }}</div>
        </div>
      </div>

      <!-- Formulario de Producto -->
      <div class="card p-2 mb-3 compact-form">
          <!-- Fila de Cliente (arriba) -->
          <div class="row g-2 mb-1">
            <div class="col-12 col-lg-5">
              <label for="rucCliente" class="form-label">RUC / CI</label>
              <div class="input-group">
                <input
                  ref="rucClienteInput"
                  type="text"
                  class="form-control form-control-sm"
                  v-model="rucCliente"
                  placeholder="Ingresa el RUC/CI del cliente"
                  @blur="verificarRUC"
                  @keyup.enter.prevent="verificarRUC"
                />
              </div>
            </div>
            <div class="col-12 col-lg-7">
              <label for="nombreCliente" class="form-label">Cliente</label>
              <div class="input-group">
                <input type="text" id="nombreCliente" class="form-control form-control-sm" v-model="clienteNombre" readonly />
                <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleBuscarCliente">
                  Buscar
                </button>
              </div>
            </div>
          </div>

          <!-- Fila de Producto (abajo) -->
          <div class="row g-2">
            <div class="col-12 col-lg-5">
              <label for="productCode" class="form-label">Código / SKU / Barcode / Nombre</label>
              <div class="input-group">
                <input
                  ref="productCodeInput"
                  type="text"
                  class="form-control form-control-sm"
                  v-model="productCode"
                  placeholder="Producto o presentación"
                  @keyup.enter.prevent="procesarCodigoPrincipal"
                />
                <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleBuscarProducto">
                  Buscar
                </button>
              </div>
              <small class="text-muted d-block mt-1">Este buscador muestra productos normales y presentaciones. Los productos a granel se cargan desde su buscador separado.</small>
            </div>
            <div class="col-12 col-sm-4 col-lg-2">
              <label for="productQuantity" class="form-label">Cantidad</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model="productQuantity"
                  value="1"
                  min="1"
                  @keyup.enter.prevent="procesarCodigoPrincipal"
                />
            </div>
            <div class="col-12 col-sm-8 col-lg-5">
              <label for="productDescription" class="form-label">Descripción del producto</label>
              <div class="input-group">
                <input
                  type="text"
                  id="productDescription"
                  class="form-control form-control-sm"
                  v-model="productDescription"
                  placeholder="Último producto cargado"
                  readonly
                />
                <button type="button" class="btn btn-success btn-sm" @click="procesarCodigoPrincipal" :disabled="!productCode">
                  <i class="bi bi-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="row g-2 mt-2">
            <div class="col-12">
              <div class="card border-0 bg-light p-2">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong>Carga manual granel</strong>
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="toggleBulkManualSection">
                    {{ mostrarCargaManualGranel ? 'Ocultar' : 'Mostrar' }}
                  </button>
                </div>
                <div v-if="mostrarCargaManualGranel" class="row g-2">
                  <div class="col-md-4">
                    <label class="form-label">Código / PLU</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="bulkManualCode"
                        placeholder="Código o PLU"
                        @keyup.enter.prevent="buscarProductoGranelManual"
                      />
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="buscarProductoGranelManual">
                        Buscar
                      </button>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Producto granel</label>
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" :value="bulkManualProductName" readonly />
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="abrirSelectorGranelManual">
                        Seleccionar
                      </button>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label class="form-label">Peso en gramos</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model="bulkManualWeight"
                      min="10"
                      step="1"
                      @keyup.enter.prevent="agregarProductoGranelManual"
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="form-label">Acción</label>
                    <button type="button" class="btn btn-success btn-sm w-100" @click="agregarProductoGranelManual">
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <!-- Overlay de selección de cliente -->
      <div
        v-if="mostrarSelectorCliente"
  class="overlay-backdrop"
  role="dialog"
  aria-modal="true"
      >
        <div class="overlay-panel card">
          <div class="overlay-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Seleccionar Cliente</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="cerrarSelectorCliente"></button>
          </div>
          <div class="overlay-body">
            <ClientesView
              :selectorMode="true"
              :hideHeader="true"
              @cliente-seleccionado="onClienteSeleccionado"
            />
          </div>
        </div>
      </div>
  
      <!-- Overlay de selección de producto -->
      <div
        v-if="mostrarSelectorProducto"
  class="overlay-backdrop"
  role="dialog"
  aria-modal="true"
      >
        <div class="overlay-panel card">
          <div class="overlay-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ bulkManualSelectorMode ? 'Seleccionar Producto a Granel' : 'Seleccionar Producto o Presentación' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="cerrarSelectorProducto"></button>
          </div>
          <div class="overlay-body">
            <ProductosPrecioView
              :selectorMode="true"
              :hideHeader="true"
              :onlyBulkProducts="bulkManualSelectorMode"
              :initialSearch="bulkManualSelectorMode ? bulkManualSelectorSearch : productCode"
              @producto-seleccionado="onProductoSeleccionado"
            />
          </div>
        </div>
      </div>

      <!-- Tabla de Productos -->
      <div class="table-container">
        <div class="sales-products-mobile d-lg-none">
          <div v-if="!productos.length" class="card shadow-sm border-0 sales-empty-state">
            <div class="card-body text-center text-muted py-4">
              Todavía no agregaste productos al pedido.
            </div>
          </div>

          <div
            v-for="(producto, index) in productosPaginados"
            :key="`mobile-${producto.producto_id || producto.codigo}-${index}`"
            class="card shadow-sm border-0 sales-product-card"
          >
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start gap-3">
                <div>
                  <div class="sales-product-card__index">
                    Ítem {{ ((paginaActual - 1) * itemsPorPagina) + (index + 1) }}
                  </div>
                  <h3 class="sales-product-card__name mb-1">{{ producto.nombre }}</h3>
                  <div class="sales-product-card__code">Código: {{ producto.codigo || '—' }}</div>
                  <div v-if="producto.es_presentacion" class="sales-product-card__code text-primary fw-semibold">Presentación</div>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  @click="eliminarProducto(absoluteProductIndex(index))"
                >
                  Quitar
                </button>
              </div>

              <div class="sales-product-card__meta">
                <div class="sales-product-card__meta-item">
                  <span class="label">Cantidad</span>
                  <strong>{{ formatCantidadVenta(producto) }}</strong>
                </div>
                <div class="sales-product-card__meta-item">
                  <span class="label">Unidad</span>
                  <strong>{{ producto.unidad_medida || '—' }}</strong>
                </div>
                <div class="sales-product-card__meta-item">
                  <span class="label">Precio</span>
                  <strong>{{ displayPrice(producto) }}</strong>
                </div>
                <div class="sales-product-card__meta-item">
                  <span class="label">Subtotal</span>
                  <strong>{{ formateaNumero(producto.subtotal ?? (producto.cantidad * producto.precio)) }} ₲</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-none d-lg-block">
          <AppTable :headers="['No. de Producto', 'Código', 'Nombre', 'Cantidad', 'Unidad de Medida', 'Precio', 'Acciones']">
            <tr v-for="(producto, index) in productosPaginados" :key="index">
              <td>{{ ((paginaActual - 1) * itemsPorPagina) + (index + 1) }}</td>
              <td>{{ producto.codigo }}</td>
              <td>
                {{ producto.nombre }}
                <span v-if="producto.es_presentacion" class="badge bg-info-subtle text-info-emphasis ms-1">Presentación</span>
              </td>
              <td>{{ formatCantidadVenta(producto) }}</td>
              <td>{{ producto.unidad_medida }}</td>
              <td>{{ displayPrice(producto) }}</td>
              <td>
                <button type="button" class="btn btn-danger btn-sm" @click="eliminarProducto(absoluteProductIndex(index))">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </AppTable>
        </div>
        <AppPagination v-if="totalPaginas > 1" :currentPage="paginaActual" :totalPages="totalPaginas" @page-changed="cambiarPagina" />
      </div>
    </div>

      <!-- Sección de Total y Acciones (justo por encima del footer real) -->
    <div class="total-footer-section">
      <h4>
        Total: <span class="ms-1">{{ formateaNumero(totalAmount) + '  ₲' }}</span>
      </h4>

      <div v-if="mostrarHintsAtajos && atajosHints.length" class="shortcuts-hint d-none d-lg-flex">
        <span v-for="hint in atajosHints" :key="hint.key" class="shortcut-hint-item">
          <kbd>{{ hint.key }}</kbd> {{ hint.label }}
        </span>
      </div>

      <!-- Reemplazo en la sección de Total y Acciones -->
      <div class="button-container">
        <button
          v-if="puedeDejarEnEspera"
          type="button"
          class="btn btn-warning"
          :disabled="enviandoPedido"
          @click="ponerVentaEnEspera"
        >
          Dejar Pedido en Espera <kbd v-if="mostrarHintsAtajos" class="ms-1 d-none d-lg-inline">F4</kbd>
        </button>
        <button type="button" class="btn btn-danger" :disabled="enviandoPedido" @click="cancelarVenta">
          {{ modoEdicion ? 'Cancelar Edición' : (modoRetomar ? 'Cancelar' : 'Cancelar Pedido') }}
          <kbd v-if="mostrarHintsAtajos" class="ms-1 d-none d-lg-inline">F8</kbd>
        </button>
        <button
          type="button"
          class="btn btn-success"
          :disabled="enviandoPedido || !productos.length"
          @click="confirmarVenta"
        >
          <span v-if="enviandoPedido" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ labelBotonPrimario }} <kbd v-if="mostrarHintsAtajos" class="ms-1 d-none d-lg-inline">F9</kbd>
        </button>
      </div>

    </div>

    <!-- Footer Fijo al Final -->
    <div class="footer d-flex w-100 align-items-center">
      <div class="flex-grow-1 text-center">
        Cajero en turno: {{ userName }} | {{ currentDate }} | Hora: {{ currentTime }}
      </div>
      <!-- FE-RTK-006: hasta el 2026-08-19 este botón NO tenía `@click`: era
           decorativo y prometía algo que nunca hizo. Ahora reimprime la última
           venta cobrada en esta pantalla, y se oculta mientras no haya
           ninguna — un botón visible que no puede cumplir es el defecto que se
           está corrigiendo. -->
      <button
        v-if="puedeReimprimirUltimo"
        type="button"
        class="btn btn-primary ms-auto"
        :disabled="reimprimiendoUltimo"
        @click="reimprimirUltimoTicket"
      >
        <span
          v-if="reimprimiendoUltimo"
          class="spinner-border spinner-border-sm me-1"
          role="status"
          aria-hidden="true"
        ></span>
        Reimprimir último ticket
      </button>
    </div>

  </div>
  
  <!-- Modal Registrar Cliente reutilizable -->
  <RegistrarClienteModal
    :open="showCrearClienteModal"
    :prefillRuc="rucCliente"
    :prefillDocumento="rucCliente"
    @saved="onClienteCreadoDesdeModal"
    @close="showCrearClienteModal = false"
  />

  <!-- Modo cajero único: cobro inline sin cambiar de ruta -->
  <CobroPedidoInlineModal
    :open="mostrarCobroInline"
    :movimiento-id="cobroInlineMovimientoId"
    :pedido-id="cobroInlinePedidoId"
    :total="cobroInlineTotal"
    :nombre-cliente="cobroInlineNombreCliente"
    @cobrado="handleCobroInlineCobrado"
    @cerrado="handleCobroInlineCerrado"
  />

  <!-- COP-7A-007: seguimiento del ticket de contingencia fiscal -->
  <EnviarSeguimientoModal
    :open="mostrarSeguimientoModal"
    :tracking-url="seguimientoTrackingUrl"
    :telefono-inicial="seguimientoTelefono"
    @cerrado="mostrarSeguimientoModal = false"
  />

</template>

<script>

import AppTable from '../components/AppTable.vue';
import AppNavbar from '../components/AppNavbar.vue';
import AppPagination from '../components/AppPagination.vue';
import apiService from '../services/apiService.js';
import operationalConfigService from '../services/operationalConfigService.js';
import { resolveSaleInput } from '@/services/saleResolverService';
import ClientesView from './ClientesView.vue';
import ProductosPrecioView from '@/views/Inventario/ProductosPrecioView.vue';
import RegistrarClienteModal from '@/components/RegistrarClienteModal.vue';
import CobroPedidoInlineModal from '@/components/CobroPedidoInlineModal.vue';
import invoiceReprintService from '@/services/invoiceReprintService';
import EnviarSeguimientoModal from '@/components/EnviarSeguimientoModal.vue';
import { hasPermission } from '@/services/authSessionService';
import { useCashboxStore } from '@/stores/cashbox';
import keyboardShortcutService from '@/services/keyboardShortcutService';
import localPrintSettingsService from '@/services/localPrintSettingsService';
import invoiceLocalPrintService from '@/services/invoiceLocalPrintService';
import { fechaIsoLocal } from '@/utils/fechaLocal.mjs';


export default {
  name: "PantallaInicio",
  components: { AppTable, AppNavbar, AppPagination, ClientesView, ProductosPrecioView, RegistrarClienteModal, CobroPedidoInlineModal, EnviarSeguimientoModal },
  data() {
    return {
      cashboxStore: useCashboxStore(),
      // Última venta cobrada EN ESTA PANTALLA. Vive en el estado del
      // componente y no en localStorage a propósito (D9 del PLAN):
      // "reimprimir el último ticket" después de recargar la página o al día
      // siguiente no es lo que el operador quiere decir con ese botón. Para
      // eso está el histórico de ventas.
      ultimaVentaCobrada: null,
      reimprimiendoUltimo: false,
      operationalConfig: operationalConfigService.getConfig(operationalConfigService.getCurrentSucursalId()),
      enviandoPedido: false,
      mostrarCobroInline: false,
      cobroInlinePedidoId: null,
      cobroInlineMovimientoId: null,
      mostrarSeguimientoModal: false,
      seguimientoTrackingUrl: '',
      seguimientoTelefono: '',
      cobroInlineTotal: 0,
      cobroInlineNombreCliente: '',
      // true cuando el operador ya vio el aviso de "cliente no cargado" y
      // volvió a presionar F9/F4 sin escribir nada: continuar como anónimo.
      clienteOmitidoConfirmado: false,
      productCode: '',
      productQuantity: 1,
      productDescription: '',
      selectedProduct: null,
      rucCliente: '',
      clienteNombre: '',
      userName: '',
      currentTime: '',
      currentDate: '',
      cabecera: {
        referencia: '',
        observaciones: '',
        tipo_entrega: 'domicilio',
        fecha_entrega: ''
      },
      productos: [],
      paginaActual: 1,
      itemsPorPagina: 5,
      showPendingModal: false,
      mostrarSelectorCliente: false,
  mostrarSelectorProducto: false,
      showCrearClienteModal: false,
      // Guardas para evitar bucles/verificaciones repetidas
      isVerifyingRuc: false,
      lastRucChecked: '',
      rucNotFoundForValue: '',
      // Guardas para búsqueda de producto
      isCheckingProduct: false,
      productNotFoundForCode: '',
      lastProductCheckedCode: '',
      mostrarCargaManualGranel: false,
      bulkManualSelectorMode: false,
      bulkManualCode: '',
      bulkManualWeight: 10,
      bulkManualSelectedProduct: null,
      bulkManualSelectorSearch: '',
      feedbackMessage: '',
      feedbackType: 'error',
      feedbackTimeoutId: null,
      // Modo edición
      modoEdicion: false,
      pedidoIdEdicion: null,
      // Modo retomar
      modoRetomar: false,
      pedidoIdRetomar: null,
      clienteTelefono: '',
      clienteDireccion: '',
      clienteEmail: ''
    };
  },
  computed: {
    totalAmount() {
      return Math.round(this.productos.reduce((acc, producto) => {
        const subtotal = Number(producto.subtotal ?? (producto.cantidad * producto.precio));
        return acc + subtotal;
      }, 0));
    },
    productosPaginados() {
    const start = (this.paginaActual - 1) * this.itemsPorPagina;
    const end = start + this.itemsPorPagina;
    return this.productos.slice(start, end);
    },
    totalPaginas() {
      return Math.ceil(this.productos.length / this.itemsPorPagina);
    },
    salesMobileTitle() {
      if (this.modoEdicion) return `Edición del Pedido #${this.pedidoIdEdicion}`;
      if (this.modoRetomar) return `Retomar Pedido #${this.pedidoIdRetomar}`;
      return 'Venta rápida y pedidos';
    },
    salesMobileSubtitle() {
      if (this.modoEdicion) return 'Guardá cambios sin salir del flujo de pedidos.';
      if (this.modoRetomar) return 'Completá el pedido y publicalo para cobro en caja.';
      return 'Cargá productos, dejá pendiente o confirmá el pedido desde el celular.';
    },
    currentSucursalId() {
      return operationalConfigService.getCurrentSucursalId();
    },
    bulkManualProductName() {
      return this.bulkManualSelectedProduct?.nombre || '';
    },
    // ====== Modo cajero único (condición triple: dónde / quién / cuándo) ======
    canCobrarEnCaja() {
      return hasPermission('cobrar_venta');
    },
    puedeReimprimirUltimo() {
      return Boolean(this.ultimaVentaCobrada?.saleId)
        && invoiceReprintService.impresionLocalHabilitada();
    },
    modoUnipersonalHabilitado() {
      return Boolean(this.operationalConfig?.modo_cajero_unico) && this.canCobrarEnCaja;
    },
    modoUnipersonalEfectivo() {
      return this.modoUnipersonalHabilitado
        && this.cashboxStore.isOpen
        && Number(this.cashboxStore.sucursalId) === Number(this.currentSucursalId);
    },
    mostrarBannerCajaCerrada() {
      // Solo aplica en modo creación: edición y retomar conservan su flujo actual sin excepción.
      return !this.modoEdicion && !this.modoRetomar
        && this.modoUnipersonalHabilitado
        && !this.modoUnipersonalEfectivo;
    },
    puedeDejarEnEspera() {
      return !this.modoEdicion && !this.modoRetomar;
    },
    labelBotonPrimario() {
      if (this.modoEdicion) return 'Guardar Edición';
      if (this.modoRetomar) return 'Completar y Enviar a Caja';
      return this.modoUnipersonalEfectivo ? 'Completar y cobrar' : 'Confirmar y Enviar a Caja';
    },
    // ====== Atajos de teclado ======
    atajosHabilitados() {
      return this.operationalConfig?.atajos_teclado_habilitados !== false;
    },
    mostrarHintsAtajos() {
      return this.atajosHabilitados && this.operationalConfig?.mostrar_hints_atajos !== false;
    },
    hayOverlayAbierto() {
      return this.mostrarSelectorCliente
        || this.mostrarSelectorProducto
        || this.showCrearClienteModal
        || this.mostrarCobroInline;
    },
    atajosHints() {
      return keyboardShortcutService.getActiveBindings('pantalla-inicio');
    }
  },
  watch: {
    productCode(newVal) {
      // Si el código cambia, invalidar la selección previa
      this.selectedProduct = null;
      if (String(newVal || '').trim()) {
        this.productDescription = '';
      }
      this.productNotFoundForCode = '';
    },
    // Si el usuario modifica el RUC/CI, permitimos reintentar y limpiamos flags
    rucCliente(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.rucNotFoundForValue = '';
        // No bloqueamos un nuevo chequeo para el nuevo valor
        this.clienteOmitidoConfirmado = false;
      }
    },
    bulkManualCode(newVal, oldVal) {
      if (newVal !== oldVal && this.bulkManualSelectedProduct) {
        const code = String(newVal || '').trim();
        const current = String(
          this.bulkManualSelectedProduct?.codigo_plu_balanza ||
          this.bulkManualSelectedProduct?.codigo_producto ||
          ''
        ).trim();
        if (code !== current) {
          this.bulkManualSelectedProduct = null;
        }
      }
    }
  },
  methods: {
    resolveApiErrorMessage(error, fallback) {
      return error?.userMessage
        || error?.response?.data?.message
        || error?.response?.data?.details
        || error?.response?.data?.error
        || fallback;
    },
    focusProductCodeInput() {
      this.$nextTick(() => {
        this.$refs.productCodeInput?.focus?.();
        this.$refs.productCodeInput?.select?.();
      });
    },
    focusRucClienteInput() {
      this.$nextTick(() => {
        this.$refs.rucClienteInput?.focus?.();
        this.$refs.rucClienteInput?.select?.();
      });
    },
    // Guarda antes de confirmar/dejar en espera: si no hay cliente cargado,
    // avisa y pone el foco en el RUC/CI en vez de mandar el pedido con una
    // búsqueda de cliente vacía. Un segundo F9/F4 sin escribir nada continúa
    // como Consumidor Final. Solo aplica en modo creación: edición y retomar
    // ya traen el cliente del pedido y no pasan por acá.
    verificarClienteAntesDeEnviar() {
      const value = (this.rucCliente || '').trim();
      if (value || this.clienteOmitidoConfirmado) return true;

      this.clienteOmitidoConfirmado = true;
      this.showInlineWarning('No cargaste el cliente. Escribí el RUC/CI o volvé a presionar para continuar como Consumidor Final.');
      this.focusRucClienteInput();
      return false;
    },
    showFeedback(message, type = 'error') {
      if (!message) return;
      this.feedbackType = type;
      this.feedbackMessage = message;
      if (this.feedbackTimeoutId) clearTimeout(this.feedbackTimeoutId);
      this.feedbackTimeoutId = setTimeout(() => {
        this.feedbackMessage = '';
      }, 2800);
    },
    showInlineWarning(message) {
      this.showFeedback(message, 'error');
    },
    refreshOperationalConfig() {
      this.operationalConfig = operationalConfigService.getConfig(this.currentSucursalId);
    },
    handleOperationalConfigChanged(event) {
      const sucursalId = Number(event?.detail?.sucursal_id || this.currentSucursalId);
      if (Number(sucursalId) !== Number(this.currentSucursalId)) return;
      this.refreshOperationalConfig();
    },
    handleGlobalSucursalChange() {
      this.refreshOperationalConfig();
      this.cashboxStore.fetchCurrentOpen({ sucursal_id: this.currentSucursalId });
    },
    irAAbrirCaja() {
      this.$router.push({ name: 'Caja' });
    },
    async reimprimirUltimoTicket() {
      const ultima = this.ultimaVentaCobrada;
      if (!ultima?.saleId || this.reimprimiendoUltimo) return;

      this.reimprimiendoUltimo = true;
      try {
        const resultado = await invoiceReprintService.reimprimirComprobante({
          saleId: ultima.saleId,
          movimientoId: ultima.movimientoId || null,
          invoiceNumber: ultima.invoiceNumber || ''
        });
        if (resultado?.omitido) return;
        const mensaje = invoiceReprintService.mensajeResultadoReimpresion(
          resultado,
          ultima.invoiceNumber || ''
        );
        this.showFeedback(mensaje.texto, mensaje.tipo === 'success' ? 'success' : 'info');
      } catch (error) {
        console.error('No se pudo reimprimir el último ticket', error);
        this.showInlineWarning(error?.message || 'No se pudo reimprimir el último ticket.');
      } finally {
        this.reimprimiendoUltimo = false;
      }
    },
    async maybePrintInvoice({ saleId, movimientoId, invoiceNumber = '', fiscal = null, printJob = null }) {
      const settings = localPrintSettingsService.getSettings();
      if (!settings.enabled || settings.invoicePrintMode === 'disabled') return;

      if (settings.invoicePrintMode === 'confirm') {
        const confirmed = await confirm({
          title: 'Imprimir factura',
          message: `La factura ${invoiceNumber || saleId} está lista. ¿Deseas enviarla ahora a la impresora local?`,
          confirmText: 'Imprimir',
          cancelText: 'Omitir'
        });
        if (!confirmed) return;
      }

      try {
        const result = await invoiceLocalPrintService.printInvoiceBySale({
          saleId,
          movimientoId,
          settings,
          printJob
        });
        if (result?.mode === 'offline_contingency' || fiscal?.status === 'OFFLINE_PENDING_SYNC') {
          this.showFeedback('Comprobante temporal enviado al agente local. Queda pendiente de validación fiscal.', 'success');
          return;
        }
        this.showFeedback('Factura enviada al cliente local de impresión.', 'success');
      } catch (error) {
        console.error('No se pudo imprimir la factura localmente', error);
        this.showInlineWarning(error?.message || 'No se pudo imprimir la factura en el cliente local.');
      }
    },
    async handleCobroInlineCobrado({ id_venta, nro_factura, vuelto, fiscal = null, printJob = null, trackingUrl = null, trackingContacto = null }) {
      const pedidoId = this.cobroInlinePedidoId;
      const movimientoId = this.cobroInlineMovimientoId;
      const mensaje = vuelto > 0
        ? `Cobro registrado. Vuelto: ${this.formateaNumero(vuelto)} ₲`
        : 'Cobro registrado correctamente.';
      this.showFeedback(mensaje, 'success');

      this.mostrarCobroInline = false;
      this.cobroInlinePedidoId = null;
      this.cobroInlineMovimientoId = null;
      this.cobroInlineTotal = 0;
      this.cobroInlineNombreCliente = '';

      if (id_venta > 0) {
        // FE-RTK-006: queda registrada para el botón de reimpresión.
        this.ultimaVentaCobrada = {
          saleId: id_venta,
          movimientoId,
          invoiceNumber: nro_factura || ''
        };
      }

      if (id_venta > 0) {
        await this.maybePrintInvoice({
          saleId: id_venta,
          movimientoId,
          invoiceNumber: nro_factura || `PEDIDO-${pedidoId}`,
          fiscal,
          printJob
        });
      }

      // COP-7A-007: el link ya viene en la respuesta del cobro (no depende
      // de la impresión local ni de que haya contingencia — el backend lo
      // arma siempre que el entorno tenga PUBLIC_TRACKING_BASE_URL
      // configurada, factura emitida o no) — ofrecer mandárselo al cliente.
      if (trackingUrl) {
        this.seguimientoTrackingUrl = trackingUrl;
        this.seguimientoTelefono = trackingContacto?.telefono || '';
        this.mostrarSeguimientoModal = true;
      }

      await this.cashboxStore.fetchCurrentOpen({ sucursal_id: this.currentSucursalId });
      this.focusProductCodeInput();
    },
    handleCobroInlineCerrado() {
      const pedidoId = this.cobroInlinePedidoId;
      this.mostrarCobroInline = false;
      this.cobroInlinePedidoId = null;
      this.cobroInlineMovimientoId = null;
      this.cobroInlineTotal = 0;
      this.cobroInlineNombreCliente = '';
      this.showFeedback(`El pedido #${pedidoId} quedó pendiente de cobro en caja.`, 'success');
      this.focusProductCodeInput();
    },
    normalizeResolvedProduct(payload) {
      const cantidad = Number(payload?.cantidad_unidades ?? payload?.peso_gramos ?? 0) || 0;
      const precio = Number(payload?.precio_venta_actual ?? 0) || 0;
      const subtotal = Number(payload?.precio_sub_total ?? (precio * cantidad)) || 0;
      const esGranel = Boolean(payload?.es_granel);
      const esPresentacion = payload?.tipo_resolucion === 'PRESENTACION' || Boolean(payload?.presentacion_id);

      const origenLectura = payload?.origen_lectura || 'NORMAL';
      const pesoGramos = esGranel
        ? (Number(payload?.peso_gramos ?? cantidad) || null)
        : null;

      return {
        producto_id: payload?.producto_id,
        presentacion_id: payload?.presentacion_id || null,
        tipo_presentacion: payload?.tipo_presentacion || null,
        codigo: payload?.codigo_barras || payload?.codigo_producto || payload?.codigo_plu_balanza || '',
        nombre: payload?.nombre || '',
        cantidad,
        unidad_medida: esPresentacion ? 'presentación' : (esGranel ? 'g' : (payload?.unidad_medida_nombre || '')),
        precio,
        subtotal,
        es_granel: esGranel,
        es_presentacion: esPresentacion,
        origen_lectura: origenLectura,
        peso_gramos: pesoGramos,
        cantidad_presentacion: payload?.cantidad_presentaciones ?? (esPresentacion ? cantidad : null),
        cantidad_unidades: payload?.cantidad_unidades ?? null,
        factor_conversion: payload?.factor_conversion ?? null,
        componentes_stock: payload?.impacto_stock_componentes || payload?.componentes_stock || [],
        codigo_balanza_raw: payload?.codigo_balanza_raw || null,
        codigo_plu_balanza: payload?.codigo_plu_balanza || null
      };
    },
    addProductoAlDetalle(productoNuevo) {
      if ((!productoNuevo?.producto_id && !productoNuevo?.presentacion_id) || !productoNuevo?.cantidad) return;

      const esLineaSeparada = Boolean(productoNuevo.es_granel || productoNuevo.es_presentacion);
      if (esLineaSeparada) {
        this.productos.push(productoNuevo);
      } else {
        const existing = this.productos.find((item) =>
          !item.es_granel &&
          !item.es_presentacion &&
          Number(item.producto_id) === Number(productoNuevo.producto_id) &&
          Number(item.precio) === Number(productoNuevo.precio)
        );

        if (existing) {
          existing.cantidad = Number(existing.cantidad || 0) + Number(productoNuevo.cantidad || 0);
          existing.subtotal = Number(existing.subtotal || 0) + Number(productoNuevo.subtotal || 0);
        } else {
          this.productos.push(productoNuevo);
        }
      }

      this.paginaActual = this.totalPaginas || 1;
    },
    formatCantidadVenta(producto) {
      const cantidad = Number(producto?.cantidad || 0);
      if (producto?.es_presentacion) return cantidad;
      if (!producto?.es_granel) return cantidad;
      if (cantidad >= 1000) return `${(cantidad / 1000).toFixed(3)} kg`;
      return `${cantidad} g`;
    },
    displayPrice(producto) {
      if (producto?.es_granel) {
        return `${this.formateaNumero(producto?.precio || 0)} ₲ / kg`;
      }
      return `${this.formateaNumero(producto?.precio || 0)} ₲`;
    },
    absoluteProductIndex(pageIndex) {
      return ((this.paginaActual - 1) * this.itemsPorPagina) + pageIndex;
    },
    toggleBuscarCliente() {
      this.mostrarSelectorCliente = !this.mostrarSelectorCliente;
      // Evitar scroll del fondo cuando está visible
      if (this.mostrarSelectorCliente) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    cerrarSelectorCliente() {
      this.mostrarSelectorCliente = false;
      document.body.style.overflow = '';
    },
    onClienteSeleccionado(cliente) {
      // Completar los datos en la pantalla de inicio y cerrar el selector
      this.rucCliente = cliente.ruc || cliente.nro_documento || '';
      this.clienteNombre = cliente.nombre_completo || cliente.nombre_fantasia || '';
      this.cerrarSelectorCliente();
    },
    abrirModalCrearClienteDesdeInicio() {
      this.showCrearClienteModal = true;
    },
    onClienteCreadoDesdeModal(cli) {
      this.rucCliente = cli?.ruc || cli?.nro_documento || this.rucCliente || '';
      this.clienteNombre = cli?.nombre_completo || cli?.nombre_fantasia || this.clienteNombre || '';
      this.showCrearClienteModal = false;
      // Resetear flags tras crear
      this.rucNotFoundForValue = '';
      this.lastRucChecked = this.rucCliente?.trim() || '';
    },
    async procesarCodigoPrincipal() {
      const code = String(this.productCode || '').trim();
      const qty = Number.parseInt(this.productQuantity, 10) || 1;
      if (!code) {
        this.focusProductCodeInput();
        return;
      }
      if (this.isCheckingProduct) return;
      if (qty <= 0) {
        this.showInlineWarning('La cantidad debe ser mayor a 0');
        this.focusProductCodeInput();
        return;
      }

      this.isCheckingProduct = true;
      try {
        const data = await resolveSaleInput({ term: code, quantity: qty });
        const producto = this.normalizeResolvedProduct(data);
        if (!producto.precio || producto.precio <= 0 || !producto.subtotal || producto.subtotal <= 0) {
          this.showInlineWarning(`El producto "${producto.nombre}" no tiene un precio aplicable.`);
          return;
        }

        this.addProductoAlDetalle(producto);
        this.selectedProduct = producto;
        this.productDescription = producto.nombre;
        this.productNotFoundForCode = '';
        this.productCode = '';
        this.productQuantity = 1;
      } catch (error) {
        const response = error?.response;
        const apiMessage = response?.data?.message || response?.data?.error;
        if (response?.status === 404 || error?.status === 404) {
          this.productNotFoundForCode = code;
          this.showInlineWarning(apiMessage || error?.message || 'Producto no encontrado. Revisá el selector.');
          this.abrirSelectorProductoConBusqueda();
        } else if (error?.status === 409) {
          this.showInlineWarning(error.message);
          this.abrirSelectorProductoConBusqueda();
        } else if (response?.status === 422) {
          this.showInlineWarning(apiMessage || 'El producto no tiene un precio aplicable');
        } else {
          console.error('Error resolviendo código de venta:', error);
          this.showInlineWarning('No fue posible cargar el producto');
        }
      } finally {
        this.lastProductCheckedCode = code;
        this.isCheckingProduct = false;
        this.focusProductCodeInput();
      }
    },
    toggleBuscarProducto() {
      this.bulkManualSelectorMode = false;
      this.mostrarSelectorProducto = !this.mostrarSelectorProducto;
      if (this.mostrarSelectorProducto) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    cerrarSelectorProducto() {
      this.mostrarSelectorProducto = false;
      this.bulkManualSelectorSearch = '';
      document.body.style.overflow = '';
    },
    abrirSelectorProductoConBusqueda() {
      this.bulkManualSelectorMode = false;
      this.mostrarSelectorProducto = true;
      document.body.style.overflow = 'hidden';
    },
    abrirSelectorGranelManual(search = '') {
      this.bulkManualSelectorMode = true;
      this.bulkManualSelectorSearch = String(search || '').trim();
      if (this.bulkManualSelectorSearch) {
        this.bulkManualSelectedProduct = null;
      }
      this.mostrarSelectorProducto = true;
      document.body.style.overflow = 'hidden';
    },
    onProductoSeleccionado(prod) {
      if (this.bulkManualSelectorMode) {
        if (!prod?.es_granel) {
          this.showInlineWarning('Seleccioná un producto configurado como granel.');
          return;
        }
        this.bulkManualSelectedProduct = prod;
        this.bulkManualCode = String(prod?.codigo_plu_balanza || prod?.codigo_producto || '').trim();
        this.cerrarSelectorProducto();
        return;
      }

      const identifier = String(prod?.codigo_barras || prod?.codigo_producto || prod?.codigo_plu_balanza || prod?.nombre || '').trim();
      if (!identifier) {
        this.showInlineWarning('El producto seleccionado no tiene código, SKU ni nombre asociado.');
        return;
      }
      this.productCode = identifier;
      this.cerrarSelectorProducto();
      this.$nextTick(() => this.procesarCodigoPrincipal());
    },
    toggleBulkManualSection() {
      this.mostrarCargaManualGranel = !this.mostrarCargaManualGranel;
      if (!this.mostrarCargaManualGranel) {
        this.bulkManualCode = '';
        this.bulkManualWeight = 10;
        this.bulkManualSelectedProduct = null;
      }
    },
    async buscarProductoGranelManual() {
      const search = String(this.bulkManualCode || '').trim();
      if (!search) {
        this.abrirSelectorGranelManual();
        return;
      }

      try {
        const { data } = await apiService.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/products/bulk/search?q=${encodeURIComponent(search)}`
        );
        const results = Array.isArray(data?.data) ? data.data : [];
        if (!results.length) {
          this.bulkManualSelectedProduct = null;
          this.showInlineWarning('No se encontró un producto a granel para ese código.');
          return;
        }

        if (results.length > 1) {
          this.abrirSelectorGranelManual(search);
          return;
        }

        const exact = results[0];

        this.bulkManualSelectedProduct = exact;
        this.bulkManualCode = String(exact.codigo_plu_balanza || exact.codigo_producto || search).trim();
      } catch (error) {
        console.error('Error buscando producto granel manual:', error);
        this.showInlineWarning('No fue posible buscar el producto a granel');
      }
    },
    async agregarProductoGranelManual() {
      const weight = Number.parseInt(this.bulkManualWeight, 10);
      const producto = this.bulkManualSelectedProduct;
      const code = String(this.bulkManualCode || '').trim();

      if ((!producto?.producto_id && !code) || !Number.isInteger(weight) || weight < 10) {
        this.showInlineWarning('Seleccioná un producto a granel y cargá un peso válido desde 10 gramos.');
        return;
      }

      try {
        const payload = producto?.producto_id
          ? { producto_id: producto.producto_id, peso_gramos: weight }
          : { codigo_plu_balanza: code, peso_gramos: weight };
        const { data } = await apiService.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/prices/bulk/manual`,
          payload
        );
        const productoNuevo = this.normalizeResolvedProduct(data);
        this.addProductoAlDetalle(productoNuevo);
        this.productDescription = productoNuevo.nombre;
        this.bulkManualCode = '';
        this.bulkManualWeight = 10;
        this.bulkManualSelectedProduct = null;
      } catch (error) {
        const response = error?.response;
        const apiMessage = response?.data?.message || response?.data?.error;
        if (response?.status === 404 || response?.status === 422 || response?.status === 400) {
          this.showInlineWarning(apiMessage || 'No fue posible cargar el producto a granel');
        } else {
          console.error('Error agregando producto granel manual:', error);
          this.showInlineWarning('Error al cargar el producto a granel');
        }
      } finally {
        this.focusProductCodeInput();
      }
    },
    async confirmarVenta() {
      if (this.enviandoPedido) return;
      this.enviandoPedido = true;
      try {
        // Validar productos
        const detalles = this.productos
          .map(p => ({
            producto_id: p.presentacion_id ? undefined : p.producto_id,
            presentacion_id: p.presentacion_id || undefined,
            cantidad: Number(p.cantidad) || 0,
            cantidad_presentacion: p.presentacion_id ? Number(p.cantidad) || 0 : undefined,
            origen_lectura: p.origen_lectura || 'NORMAL',
            codigo_plu_balanza: p.codigo_plu_balanza || null,
            codigo_balanza_raw: p.codigo_balanza_raw || null,
            peso_gramos: p.peso_gramos ?? null
          }))
          .filter(item => item.cantidad > 0);

        if (!detalles.length) {
          this.showInlineWarning('Agregá al menos un producto antes de confirmar.');
          return;
        }

        // ====== MODO RETOMAR ======
        if (this.modoRetomar && this.pedidoIdRetomar) {
          const payload = {
            descripcion: "Completar pedido retomado y publicarlo a caja",
            moneda: "PYG",
            idempotency_key: "",
            cabecera: {
              nombre_cliente: this.clienteNombre || 'Cliente sin nombre',
              telefono: this.clienteTelefono || '',
              direccion: this.clienteDireccion || '',
              email: this.clienteEmail || ''
            },
            confirmar: true, // En modo retomar confirmamos para completar el pedido
            detalles
          };

          const resp = await apiService.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/orders/pending/${this.pedidoIdRetomar}`,
            payload
          );
          const resultado = resp?.data;
          if (!resultado?.ok) {
            throw new Error('El backend devolvió una respuesta inesperada.');
          }
          this.showFeedback(`Pedido #${this.pedidoIdRetomar} completado y enviado a caja.`, 'success');
          
          // Volver a GestionPedidos
          this.$router.push({ name: 'GestionPedidos' });
          return;
        }

        // ====== MODO EDICIÓN ======
        if (this.modoEdicion && this.pedidoIdEdicion) {
          const payload = {
            descripcion: "Guardar edición de pedido pendiente",
            moneda: "PYG",
            idempotency_key: "",
            cabecera: {
              nombre_cliente: this.clienteNombre || 'Cliente sin nombre',
              telefono: this.clienteTelefono || '',
              direccion: this.clienteDireccion || '',
              email: this.clienteEmail || ''
            },
            confirmar: false, // En modo edición siempre es false (solo pedidos pendientes)
            detalles
          };

          const resp = await apiService.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/orders/pending/${this.pedidoIdEdicion}`,
            payload
          );
          const resultado = resp?.data;
          if (!resultado?.ok) {
            throw new Error('El backend devolvió una respuesta inesperada.');
          }
          this.showFeedback(`Pedido #${this.pedidoIdEdicion} editado correctamente.`, 'success');
          
          // Volver a GestionPedidos
          this.$router.push({ name: 'GestionPedidos' });
          return;
        }

        // ====== MODO CREACIÓN (código original) ======
        if (!this.verificarClienteAntesDeEnviar()) {
          return;
        }

        const rucTrimmed = (this.rucCliente || '').trim();
        let cliente = null;
        if (rucTrimmed) {
          try {
            const respCliente = await apiService.get(
              `${process.env.VUE_APP_API_BASE_URL}/api/clients/search/${rucTrimmed}`
            );
            cliente = respCliente?.data ?? null;
          } catch (errorCliente) {
            if (errorCliente?.response?.status !== 404) {
              throw errorCliente;
            }
          }
        }

        const nro_documento = rucTrimmed
          || cliente?.nro_documento
          || cliente?.ruc
          || cliente?.ci
          || '';
        const nombre_cliente = this.clienteNombre
          || cliente?.nombre_completo
          || cliente?.nombre_fantasia
          || '';
        const telefono = cliente?.telefono ?? '';
        const direccion = cliente?.direccion ?? '';
        const email = cliente?.email ?? '';
        const fecha_entrega = this.resolveFechaEntrega();

        const nombreFinal = nombre_cliente || 'Cliente sin nombre';
        const documentoFinal = nro_documento || 'S/D';

        const cab = {
          nombre_cliente: nombreFinal,
          nro_documento: documentoFinal,
          telefono,
          direccion,
          email,
          fecha_entrega,
          tipo_entrega: this.cabecera.tipo_entrega,
          sucursal_id: this.currentSucursalId
        };

        const payload = { cabecera: cab, detalles, confirmar: true };

        const resp = await apiService.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/orders/pending`,
          payload
        );
        const resultado = resp?.data;
        if (!resultado?.ok) {
          throw new Error('El backend devolvió una respuesta inesperada.');
        }
        const pedidoId = resultado?.data?.pedido_id;
        const movimientoId = resultado?.data?.caja_movimiento_id;

        // Modo cajero único efectivo: el pedido ya quedó publicado en caja
        // (igual que en el flujo normal); en vez de solo avisar, se abre el
        // cobro inline sin cambiar de ruta.
        if (this.modoUnipersonalEfectivo) {
          if (!movimientoId) {
            this.showFeedback(
              pedidoId
                ? `Pedido #${pedidoId} enviado a caja. No se pudo abrir el cobro: cobralo desde Caja › Cobrar pedidos.`
                : 'Pedido enviado a caja. No se pudo abrir el cobro: cobralo desde Caja › Cobrar pedidos.',
              'success'
            );
            this.limpiarFormulario();
            return;
          }

          this.cobroInlinePedidoId = pedidoId;
          this.cobroInlineMovimientoId = movimientoId;
          this.cobroInlineTotal = this.totalAmount;
          this.cobroInlineNombreCliente = nombreFinal;
          this.mostrarCobroInline = true;

          // El pedido ya está confirmado y publicado; el modal de cobro
          // opera con sus propios props, no depende del estado local del
          // formulario. skipFocus evita pelear por el foco con el modal.
          this.limpiarFormulario({ skipFocus: true });
          return;
        }

        const mensaje = pedidoId
          ? `Pedido #${pedidoId} completado y enviado a caja.`
          : 'Pedido completado y enviado a caja.';
        this.showFeedback(mensaje, 'success');

        // Limpiar estado local
        this.limpiarFormulario();
      } catch (error) {
        console.error('Error al confirmar venta:', error);
        const fallback = this.modoRetomar
          ? 'Error al completar el pedido'
          : (this.modoEdicion ? 'Error al editar el pedido' : 'Error al registrar el pedido');
        const mensajeError = this.resolveApiErrorMessage(error, fallback);
        this.showInlineWarning(mensajeError);
      } finally {
        this.enviandoPedido = false;
      }
    },
    async eliminarProducto(index) {
      const confirmed = await confirm({
        message: '¿Estás seguro de que deseas eliminar este producto?',
        title: 'Eliminar producto del pedido',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar'
      });
      if (confirmed) {
        if (index < 0 || index >= this.productos.length) return;
        this.productos.splice(index, 1);
        if (this.paginaActual > this.totalPaginas) {
          this.paginaActual = Math.max(this.totalPaginas, 1);
        }
      }
    },
    async cancelarVenta() {
      const mensaje = this.modoEdicion
        ? '¿Seguro que deseas cancelar la edición y volver a la lista de pedidos?'
        : (this.modoRetomar 
          ? '¿Seguro que deseas cancelar y volver a la lista de pedidos?'
          : '¿Seguro que deseas cancelar la venta y limpiar todos los campos?');
      const confirmado = await confirm({
        message: mensaje,
        title: 'Confirmar cancelación',
        confirmText: 'Sí, cancelar',
        cancelText: 'Continuar'
      });
      if (!confirmado) return;
      
      // Si estamos en modo edición o retomar, volver a GestionPedidos
      if (this.modoEdicion || this.modoRetomar) {
        this.$router.push({ name: 'GestionPedidos' });
      }
      
      this.limpiarFormulario();
    },
    cancelarEdicion() {
      // Método específico para el botón X del alert de edición
      this.$router.push({ name: 'GestionPedidos' });
    },
    cancelarRetomar() {
      // Método específico para el botón X del alert de retomar
      this.$router.push({ name: 'GestionPedidos' });
    },
    limpiarFormulario({ skipFocus = false } = {}) {
      // Limpia todos los inputs y estados locales de la pantalla
      this.productos = [];
      this.paginaActual = 1;
      this.cabecera.referencia = '';
      this.cabecera.observaciones = '';
      this.cabecera.tipo_entrega = 'domicilio';
      this.cabecera.fecha_entrega = '';
      this.productCode = '';
      this.productQuantity = 1;
      this.productDescription = '';
      this.selectedProduct = null;
      this.bulkManualCode = '';
      this.bulkManualWeight = 10;
      this.bulkManualSelectedProduct = null;
      this.mostrarCargaManualGranel = false;
      this.bulkManualSelectorMode = false;
      this.feedbackMessage = '';
      this.rucCliente = '';
      this.clienteNombre = '';
      this.clienteOmitidoConfirmado = false;
      this.showPendingModal = false;
      // Resetear modo edición
      this.modoEdicion = false;
      this.pedidoIdEdicion = null;
      // Resetear modo retomar
      this.modoRetomar = false;
      this.pedidoIdRetomar = null;
      this.clienteTelefono = '';
      this.clienteDireccion = '';
      this.clienteEmail = '';
      if (!skipFocus) {
        this.focusProductCodeInput();
      }
    },
    cambiarPagina(page) {
      this.paginaActual = page;
    },
    async ponerVentaEnEspera() {
      try {
        // Validar productos
        const detalles = this.productos
          .map(p => ({
            producto_id: p.presentacion_id ? undefined : p.producto_id,
            presentacion_id: p.presentacion_id || undefined,
            cantidad: Number(p.cantidad) || 0,
            cantidad_presentacion: p.presentacion_id ? Number(p.cantidad) || 0 : undefined,
            origen_lectura: p.origen_lectura || 'NORMAL',
            codigo_plu_balanza: p.codigo_plu_balanza || null,
            codigo_balanza_raw: p.codigo_balanza_raw || null,
            peso_gramos: p.peso_gramos ?? null
          }))
          .filter(item => item.cantidad > 0);

        if (!detalles.length) {
          this.showInlineWarning('Agregá al menos un producto antes de poner la venta en espera.');
          return;
        }

        if (!this.verificarClienteAntesDeEnviar()) {
          return;
        }

        // Obtener información del cliente
        const rucTrimmed = (this.rucCliente || '').trim();
        let cliente = null;
        if (rucTrimmed) {
          try {
            const respCliente = await apiService.get(
              `${process.env.VUE_APP_API_BASE_URL}/api/clients/search/${rucTrimmed}`
            );
            cliente = respCliente?.data ?? null;
          } catch (errorCliente) {
            if (errorCliente?.response?.status !== 404) {
              throw errorCliente;
            }
          }
        }

        const nro_documento = rucTrimmed
          || cliente?.nro_documento
          || cliente?.ruc
          || cliente?.ci
          || '';
        const nombre_cliente = this.clienteNombre
          || cliente?.nombre_completo
          || cliente?.nombre_fantasia
          || '';
        const telefono = cliente?.telefono ?? '';
        const direccion = cliente?.direccion ?? '';
        const email = cliente?.email ?? '';
        const fecha_entrega = this.resolveFechaEntrega();

        const nombreFinal = nombre_cliente || 'Cliente sin nombre';
        const documentoFinal = nro_documento || 'S/D';

        const cab = {
          nombre_cliente: nombreFinal,
          nro_documento: documentoFinal,
          telefono,
          direccion,
          email,
          fecha_entrega,
          tipo_entrega: this.cabecera.tipo_entrega,
          sucursal_id: this.currentSucursalId
        };

        const payload = { cabecera: cab, detalles, confirmar: false };

        const resp = await apiService.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/orders/pending`,
          payload
        );
        const resultado = resp?.data;
        if (!resultado?.ok) {
          throw new Error('El backend devolvió una respuesta inesperada.');
        }
        const pedidoId = resultado?.data?.pedido_id;
        const mensaje = pedidoId
          ? `Pedido #${pedidoId} puesto en espera correctamente.`
          : 'Venta puesta en espera correctamente.';
        this.showFeedback(mensaje, 'success');
        
        // Limpiar estado local
        this.limpiarFormulario();
      } catch (error) {
        console.error('Error al poner venta en espera:', error);
        this.showInlineWarning('Error al poner la venta en espera.');
      }
    },
    async verificarRUC() {
      const value = (this.rucCliente || '').trim();
      if (!value) return;
      // Evitar doble ejecución por Enter + blur y evitar reintentos infinitos para el mismo valor
      if (this.isVerifyingRuc) return;
      if (this.rucNotFoundForValue === value) return; // ya se intentó y no se encontró; esperar cambio del input
      if (this.showCrearClienteModal) return; // si el modal ya está abierto, no volver a disparar

      this.isVerifyingRuc = true;
      try {
        const url = `${process.env.VUE_APP_API_BASE_URL}/api/clients/search/${value}`;
        const { data: cliente } = await apiService.get(url);
        if (cliente && Object.keys(cliente).length > 0) {
          this.clienteNombre = cliente.nombre_completo || '';
        } else {
          this.clienteNombre = '';
          this.rucNotFoundForValue = value;
          this.abrirModalCrearClienteDesdeInicio();
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          this.clienteNombre = '';
          this.rucNotFoundForValue = value;
          this.abrirModalCrearClienteDesdeInicio();
        } else {
          console.error('Error al verificar RUC:', error);
        }
      } finally {
        this.lastRucChecked = value;
        this.isVerifyingRuc = false;
      }
    },
    mostrarReloj() {
      const fecha = new Date();
      const hr = this.formatoHora(fecha.getHours());
      const min = this.formatoHora(fecha.getMinutes());
      const seg = this.formatoHora(fecha.getSeconds());
      this.currentTime = `${hr}:${min}:${seg}`;

      const meses = ['Ene', 'Feb', 'Marz', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      const dias = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

      const diaSemana = dias[fecha.getDay()];
      const diaDelMes = fecha.getDate();
      const mes = meses[fecha.getMonth()];
      const anho = fecha.getFullYear();
      this.currentDate = `${diaSemana}, ${diaDelMes} ${mes}, ${anho}`;
    },
    formatoHora(hora) {
      return hora < 10 ? '0' + hora : hora;
    },
    formateaNumero (n) {
      if (n === null || n === undefined) return ''
      return Number(n).toLocaleString('es-PY', { minimumFractionDigits: 0 })
    },
    redondearHaciaArriba(valor) {
      if (valor === null || valor === undefined || isNaN(valor)) return 0;
      return Math.round(Number(valor));
    },
    resolveFechaEntrega() {
      const raw = this.cabecera?.fecha_entrega;
      if (raw instanceof Date && !isNaN(raw)) {
        return fechaIsoLocal(raw);
      }
      if (typeof raw === 'string' && raw.trim()) {
        return raw.trim();
      }
      return fechaIsoLocal();
    }
  },
  mounted() {
    this.userName = localStorage.getItem("user_name") || '';
    this.mostrarReloj();
    this._timeInterval = setInterval(this.mostrarReloj, 1000);
    this.focusProductCodeInput();

    // Modo cajero único: config operativa + estado de caja del usuario.
    this.refreshOperationalConfig();
    this.cashboxStore.fetchCurrentOpen({ sucursal_id: this.currentSucursalId });
    window.addEventListener('app:operational-config-changed', this.handleOperationalConfigChanged);
    window.addEventListener('app:sucursal-changed', this.handleGlobalSucursalChange);

    // Atajos de teclado: cada tecla invoca el mismo método que su botón
    // visible. F9 nunca es Enter (los lectores de código de barras emiten
    // Enter al final de cada lectura y confirmarían pedidos a medio cargar).
    this._unregisterShortcuts = keyboardShortcutService.register({
      scopeId: 'pantalla-inicio',
      isActive: () => this.atajosHabilitados && !this.hayOverlayAbierto,
      bindings: [
        { key: 'F2', run: () => this.focusProductCodeInput(), label: 'Buscar' },
        {
          key: 'F4',
          run: () => this.ponerVentaEnEspera(),
          enabled: () => this.puedeDejarEnEspera,
          label: 'En espera'
        },
        { key: 'F8', run: () => this.cancelarVenta(), label: 'Cancelar' },
        {
          key: 'F9',
          run: () => this.confirmarVenta(),
          enabled: () => !this.enviandoPedido,
          label: () => this.labelBotonPrimario
        }
      ]
    });

    // Verificar si venimos desde edición de pedido
    if (this.$route.query.modo === 'edicion') {
      this.modoEdicion = true;
      this.pedidoIdEdicion = this.$route.query.pedidoId;
      this.clienteNombre = this.$route.query.clienteNombre || '';
      this.rucCliente = this.$route.query.clienteDocumento || '';
      this.clienteTelefono = this.$route.query.clienteTelefono || '';
      this.clienteDireccion = this.$route.query.clienteDireccion || '';
      this.clienteEmail = this.$route.query.clienteEmail || '';
      
      // Cargar productos desde JSON
      try {
        const productosParam = JSON.parse(this.$route.query.productos || '[]');
        this.productos = productosParam.map(detalle => ({
          producto_id: detalle.producto_id,
          presentacion_id: detalle.presentacion_id || null,
          tipo_presentacion: detalle.tipo_presentacion || null,
          codigo: detalle.codigo_barras || detalle.codigo || '',
          nombre: detalle.producto_nombre || detalle.nombre || '',
          cantidad: detalle.cantidad || 0,
          unidad_medida: detalle.unidad_medida_nombre || '',
          precio: detalle.precio_unitario || detalle.precio || 0,
          subtotal: Number(detalle.subtotal ?? ((detalle.precio_unitario || detalle.precio || 0) * (detalle.cantidad || 0))) || 0,
          es_granel: Boolean(detalle.es_granel),
          es_presentacion: Boolean(detalle.presentacion_id),
          cantidad_presentacion: detalle.cantidad_presentacion || null,
          cantidad_unidades: detalle.cantidad_unidades || null,
          factor_conversion: detalle.factor_conversion || null,
          componentes_stock: detalle.componentes_stock || [],
          peso_gramos: detalle.peso_gramos || null,
          codigo_balanza_raw: detalle.codigo_balanza_raw || null,
          origen_lectura: detalle.origen_lectura || 'NORMAL'
        }));
      } catch (error) {
        console.error('Error al parsear productos:', error);
        this.productos = [];
      }
    }
    
    // Verificar si venimos desde retomar pedido
    if (this.$route.query.modo === 'retomar') {
      this.modoRetomar = true;
      this.pedidoIdRetomar = this.$route.query.pedidoId;
      this.clienteNombre = this.$route.query.clienteNombre || '';
      this.rucCliente = this.$route.query.clienteDocumento || '';
      this.clienteTelefono = this.$route.query.clienteTelefono || '';
      this.clienteDireccion = this.$route.query.clienteDireccion || '';
      this.clienteEmail = this.$route.query.clienteEmail || '';
      
      // Cargar productos desde JSON
      try {
        const productosParam = JSON.parse(this.$route.query.productos || '[]');
        this.productos = productosParam.map(detalle => ({
          producto_id: detalle.producto_id,
          presentacion_id: detalle.presentacion_id || null,
          tipo_presentacion: detalle.tipo_presentacion || null,
          codigo: detalle.codigo_barras || detalle.codigo || '',
          nombre: detalle.producto_nombre || detalle.nombre || '',
          cantidad: detalle.cantidad || 0,
          unidad_medida: detalle.unidad_medida_nombre || '',
          precio: detalle.precio_unitario || detalle.precio || 0,
          subtotal: Number(detalle.subtotal ?? ((detalle.precio_unitario || detalle.precio || 0) * (detalle.cantidad || 0))) || 0,
          es_granel: Boolean(detalle.es_granel),
          es_presentacion: Boolean(detalle.presentacion_id),
          cantidad_presentacion: detalle.cantidad_presentacion || null,
          cantidad_unidades: detalle.cantidad_unidades || null,
          factor_conversion: detalle.factor_conversion || null,
          componentes_stock: detalle.componentes_stock || [],
          peso_gramos: detalle.peso_gramos || null,
          codigo_balanza_raw: detalle.codigo_balanza_raw || null,
          origen_lectura: detalle.origen_lectura || 'NORMAL'
        }));
      } catch (error) {
        console.error('Error al parsear productos:', error);
        this.productos = [];
      }
    }
  },
  beforeUnmount() {
    clearInterval(this._timeInterval);
    if (this.feedbackTimeoutId) clearTimeout(this.feedbackTimeoutId);
    window.removeEventListener('app:operational-config-changed', this.handleOperationalConfigChanged);
    window.removeEventListener('app:sucursal-changed', this.handleGlobalSucursalChange);
    if (this._unregisterShortcuts) {
      this._unregisterShortcuts();
      this._unregisterShortcuts = null;
    }
  },

};
</script>

<style scoped>
/* Se mantienen los estilos actuales */
body {
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
  overflow: hidden;
}

.navbar-dark .navbar-nav .nav-link {
  color: white;
  font-weight: bold;
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: #ddd;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.sales-screen {
  padding-bottom: 130px;
}

.table-container {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: auto;
  padding-bottom: 95px;
}

.table {
  border: 2px solid #000;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.table thead th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  border-bottom: 2px solid #000;
}

.button-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.total-footer-section h4 {
  display: flex;
  justify-content: center;
}

.total-footer-section {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  width: 100vw;
  background-color: #e9ecef;
  padding: 10px 20px;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 1000;
  box-sizing: border-box;
}

h4 span {
  color: #ff5722;
}

.shortcuts-hint {
  align-items: center;
  gap: 14px;
  color: #495057;
  font-size: 0.8rem;
  white-space: nowrap;
}

.shortcuts-hint .shortcut-hint-item kbd {
  font-size: 0.7rem;
  padding: 1px 5px;
  margin-right: 2px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #343a40;
  color: white;
  padding: 10px 20px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  box-sizing: border-box;
}

.footer .d-flex {
  justify-content: space-between;
  width: 100%;
}

.gap-3 {
  gap: 10px;
}

.footer .btn {
  padding: 5px 10px;
  font-size: 14px;
}

.total-footer-section h4 {
  padding-left: 100px;
}

/* Compact form styles to reduce vertical space above the table */
.compact-form {
  padding: 8px !important;
}
.compact-form .form-label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
.compact-form .input-group > .form-control,
.compact-form .form-control.form-control-sm {
  height: 32px;
  padding: 0.25rem 0.5rem;
}
.compact-form .btn,
.compact-form .btn-sm {
  padding: 0.25rem 0.5rem;
  line-height: 1.1;
}
.compact-form .row {
  margin-right: 0;
  margin-left: 0;
}

.sales-context-card {
  background: linear-gradient(145deg, #f6f1df 0%, #ffffff 100%);
  border: 1px solid rgba(173, 125, 38, 0.12);
}

.sales-context-card__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8c5d1d;
  margin-bottom: 0.35rem;
}

.sales-context-card__title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2937;
}

.sales-context-card__subtitle {
  font-size: 0.92rem;
  color: #6b7280;
  margin-top: 0.35rem;
}

.sales-products-mobile {
  display: grid;
  gap: 0.75rem;
}

.sales-product-card,
.sales-empty-state {
  border-radius: 16px;
}

.sales-product-card__index {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #8c5d1d;
  margin-bottom: 0.35rem;
}

.sales-product-card__name {
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
}

.sales-product-card__code {
  font-size: 0.88rem;
  color: #6b7280;
}

.sales-product-card__meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
  margin-top: 1rem;
}

.sales-product-card__meta-item {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0.75rem;
}

.sales-product-card__meta-item .label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

/* Fullscreen overlay for embedded client selector */
.overlay-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000; /* above footer and total section */
}
.overlay-panel {
  width: 95vw;
  max-width: 1100px;
  max-height: 90vh;
  overflow: hidden;
}
.overlay-header {
  border-bottom: 1px solid #e9ecef;
  padding: 10px 14px; /* ligeramente más compacto */
}
.overlay-body {
  padding: 6px 12px 12px; /* reducir espacio superior */
  max-height: calc(90vh - 56px);
  overflow: auto;
}

@media (max-width: 991.98px) {
  body {
    overflow: auto;
  }

  .container {
    overflow: visible;
  }

  .sales-screen {
    padding-bottom: 1rem;
  }

  .table-container {
    overflow: visible;
    padding-bottom: 1rem;
  }

  .total-footer-section {
    position: static;
    width: auto;
    height: auto;
    margin: 0 0.75rem 0.75rem;
    padding: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
    display: block;
  }

  .total-footer-section h4 {
    justify-content: flex-start;
    margin-bottom: 1rem;
    padding-left: 0;
  }

  .button-container {
    flex-direction: column;
    align-items: stretch;
  }

  .button-container .btn {
    width: 100%;
  }

  .footer {
    position: static;
    height: auto;
    padding: 1rem;
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
  }

  .footer .btn {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .sales-product-card__meta {
    grid-template-columns: 1fr;
  }
}
</style>
